import { fAmount } from "kz-ui-sdk";

/**
 * Transforms a number into a formatted string with hyphens based on its length.
 * Logic for rolling number in slot machine
 * @example
 * Input: 0.10 -> 0-.-1-0
 * Input: 1,00 -> 1-,-0-0
 * Input: 10.00 -> 1-0.0-0
 * Input: 100.00 -> 100-.00
 * Input: 1,000.00 -> 1,000.00
 */
export const toRollingFormat = (input: number) => {
  const formattedInput = fAmount(input); // Converts 1000 to "1,000.00"
  const inputLength = formattedInput.length;
  if (inputLength === 3) {
    return `${formattedInput[0]}-${formattedInput[1]}-${formattedInput[2]}`;
  } else if (inputLength === 4) {
    return `${formattedInput[0]}-${formattedInput[1]}-${formattedInput[2]}-${formattedInput[3]}`;
  } else if (inputLength === 5) {
    return `${formattedInput[0]}-${formattedInput[1]}${formattedInput[2]}${formattedInput[3]}-${formattedInput[4]}`;
  } else if (inputLength === 6) {
    return `${formattedInput[0]}${formattedInput[1]}${formattedInput[2]}-${formattedInput[3]}${formattedInput[4]}${formattedInput[5]}`;
  }
  return formattedInput;
};
